/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Tenant-level defaults for oral exam event kinds.
 */
export interface OralExamEventKindDefaults {
  questionCount?: number;
  secondsPerQuestion?: number;
}
